import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private cache = new Map<string, any>();

  constructor() { }

  setCache(key: string, data: any) {
    this.cache.set(key, data);
  }

  getCache(key: string): any {
    const cacheEntry = this.cache.get(key);
    if (cacheEntry) {
      return cacheEntry;
    }
    return null;
  }

  deleteCache(key: string) {
    this.cache.delete(key);
  }

  createCacheKey(url: string, body: any): string {
    const bodyHash = this.simpleHash(JSON.stringify(body)).toString();

    return `${url}_${bodyHash}`;
  }

  private simpleHash(str: string): string {
    let hash = 0;
    if (str.length === 0) {
      return hash.toString();
    }
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash // Convert to 32bit integer
    }
    return hash.toString();
  }
}
